console.log('Modal module loaded');


// WEBPACK FOOTER //
// ./wp-content/themes/usdigitalpartners/modules/modal-module/includes/modal-module.js